import { useState, useEffect, useCallback } from 'react';

var API = 'https://api.algrok.com';

function fmtINR(n) {
  if (n == null || isNaN(n)) return '--';
  var sign = n < 0 ? '−' : '+';
  return sign + '₹' + Math.abs(n).toLocaleString('en-IN', { maximumFractionDigits: 0 });
}
function fmtOI(v) {
  if (v == null || isNaN(v)) return '--';
  var a = Math.abs(v), s = v < 0 ? '−' : '';
  return a >= 1e7 ? s + (a / 1e7).toFixed(2) + 'Cr' : a >= 1e5 ? s + (a / 1e5).toFixed(1) + 'L' : s + String(Math.round(a));
}
function fmtCr(v, sign) {
  if (v == null || isNaN(v)) return '--';
  var s = sign && v > 0 ? '+' : v < 0 ? '−' : '';
  return s + Math.abs(v).toLocaleString('en-IN', { maximumFractionDigits: 0 }) + ' Cr';
}
function num(v) { return v == null ? '--' : Number(v).toLocaleString('en-IN'); }

var C = { card: '#0a0f1c', line: '#1f2937', mut: '#556677', sub: '#8b98a9', red: '#ef4444', grn: '#22c55e', blu: '#38bdf8', amb: '#fbbf24', vio: '#a78bfa' };
var cardBase = { background: C.card, border: '1px solid ' + C.line, borderRadius: 12, padding: '12px 14px' };
var LBL = { fontSize: 10, fontWeight: 800, letterSpacing: 1, color: C.mut };
var FIELD_LBL = { fontSize: 12, color: C.sub, marginBottom: 5 };
var FIELD_IN = { width: '100%', boxSizing: 'border-box', background: '#0d1524', border: '1px solid #26334a', borderRadius: 8, color: '#e5e7eb', fontSize: 14, padding: '9px 12px', fontFamily: 'inherit' };

function Field(props) {
  return (
    <div>
      <div style={FIELD_LBL}>{props.label}{props.hint ? <span style={{ color: C.mut, fontSize: 10 }}> {props.hint}</span> : null}</div>
      {props.options ? (
        <select value={props.value} onChange={function (e) { props.onChange(e.target.value); }} style={FIELD_IN}>
          {props.options.map(function (o) { return <option key={o[0]} value={o[0]}>{o[1]}</option>; })}
        </select>
      ) : (
        <input type={props.type || 'text'} value={props.value} onChange={function (e) { props.onChange(e.target.value); }} style={FIELD_IN} />
      )}
    </div>
  );
}

function Stat(props) {
  return (
    <div style={{ ...cardBase, flex: 1, minWidth: 110 }}>
      <div style={LBL}>{props.label}</div>
      <div style={{ fontSize: 18, fontWeight: 800, marginTop: 2, color: props.color || '#e5e7eb' }}>{props.value}</div>
    </div>
  );
}

function Chip(props) {
  return <span style={{ fontSize: 9, fontWeight: 800, borderRadius: 6, padding: '3px 8px', border: '1px solid ' + props.color + '80', background: props.color + '1a', color: props.color }}>{props.children}</span>;
}

// ── strike chart (SVG) ──────────────────────────────────────────────
function StrikeChart(props) {
  var rows = props.rows || [], tab = props.tab, v = props.view || {};
  var s = v.suggestion || {};
  if (!rows.length) return <div style={{ fontSize: 11, color: C.mut, padding: '60px 0', textAlign: 'center' }}>Waiting for chain data…</div>;
  var W = 820, H = 300, L = 44, R = 10, T = 22, B = 34;
  var n = rows.length, cw = (W - L - R) / n, mid = T + (H - T - B) / 2, base = H - B, ph = H - T - B;
  var k0 = rows[0].strike, k1 = rows[n - 1].strike, step = n > 1 ? (rows[1].strike - k0) : 50;
  function xOfK(k) { return L + (k - k0) / step * cw + cw / 2; }
  var picks = [s.ce_strike, s.pe_strike];
  var els = [];
  var vals, mx, colorOf;

  if (tab === 'oi') {
    mx = Math.max.apply(null, rows.map(function (r) { return Math.max(r.ce_oi || 0, r.pe_oi || 0); })) || 1;
    rows.forEach(function (r, i) {
      var x = L + i * cw, hc = (r.ce_oi || 0) / mx * ph, hp = (r.pe_oi || 0) / mx * ph;
      var hi = picks.indexOf(r.strike) > -1;
      els.push(<rect key={'c' + i} x={x + cw * 0.12} y={base - hc} width={cw * 0.36} height={hc} fill={C.red} opacity={hi ? 1 : 0.5} />);
      els.push(<rect key={'p' + i} x={x + cw * 0.52} y={base - hp} width={cw * 0.36} height={hp} fill={C.grn} opacity={hi ? 1 : 0.5} />);
      if (props.showChg) {
        var cc = Math.max(0, r.ce_oi_chg || 0) / mx * ph, pc = Math.max(0, r.pe_oi_chg || 0) / mx * ph;
        els.push(<rect key={'cc' + i} x={x + cw * 0.12} y={base - cc} width={cw * 0.36} height={cc} fill="#fff" opacity={0.35} />);
        els.push(<rect key={'pc' + i} x={x + cw * 0.52} y={base - pc} width={cw * 0.36} height={pc} fill="#fff" opacity={0.35} />);
      }
    });
  } else if (tab === 'all') {
    mx = Math.max.apply(null, rows.map(function (r) { return Math.max(r.ce_score || 0, r.pe_score || 0); })) || 1;
    rows.forEach(function (r, i) {
      var x = L + i * cw, sc = (r.ce_score || 0) > 0 ? r.ce_score : -(r.pe_score || 0);
      if (!sc) return;
      var h = Math.abs(sc) / mx * ph / 2, y = sc > 0 ? mid - h : mid;
      var hi = picks.indexOf(r.strike) > -1;
      els.push(<rect key={i} x={x + cw * 0.15} y={y} width={cw * 0.7} height={h} fill={sc > 0 ? C.red : C.grn} opacity={hi ? 1 : 0.45} stroke={hi ? '#fff' : 'none'} strokeWidth={hi ? 1 : 0} />);
    });
    els.push(<line key="mid" x1={L} x2={W - R} y1={mid} y2={mid} stroke="#26334a" />);
  } else {
    var key = tab === 'gex' ? 'net_gex' : (props.fresh ? 'fresh_dex' : 'net_dex');
    vals = rows.map(function (r) { return r[key] || 0; });
    mx = Math.max.apply(null, vals.map(Math.abs)) || 1;
    rows.forEach(function (r, i) {
      var val = vals[i], h = Math.abs(val) / mx * ph / 2, y = val >= 0 ? mid - h : mid;
      var wall = tab === 'gex' && (r.strike === v.call_wall || r.strike === v.put_wall);
      colorOf = val >= 0 ? C.grn : C.red;
      els.push(<rect key={i} x={L + i * cw + cw * 0.15} y={y} width={cw * 0.7} height={h} fill={colorOf} opacity={wall ? 1 : 0.6} stroke={wall ? '#fff' : 'none'} strokeWidth={wall ? 1 : 0} />);
    });
    els.push(<line key="mid" x1={L} x2={W - R} y1={mid} y2={mid} stroke="#26334a" />);
  }

  // strike labels
  rows.forEach(function (r, i) {
    if (r.strike % 100 === 0) els.push(<text key={'t' + i} x={L + i * cw + cw / 2} y={H - B + 15} fill={C.mut} fontSize="10" textAnchor="middle">{r.strike}</text>);
  });
  // spot / flip lines
  if (v.spot && v.spot >= k0 && v.spot <= k1) {
    var sx = xOfK(v.spot);
    els.push(<line key="spot" x1={sx} x2={sx} y1={T} y2={H - B} stroke={C.blu} strokeDasharray="4 3" />);
    els.push(<text key="spott" x={sx + 4} y={T + 9} fill={C.blu} fontSize="10" fontWeight="800">SPOT {num(Math.round(v.spot))}</text>);
  }
  if ((tab === 'gex' || tab === 'all') && v.gamma_flip && v.gamma_flip >= k0 && v.gamma_flip <= k1) {
    var fx = xOfK(v.gamma_flip);
    els.push(<line key="flip" x1={fx} x2={fx} y1={T} y2={H - B} stroke={C.amb} strokeDasharray="2 3" />);
    els.push(<text key="flipt" x={fx + 4} y={T + 22} fill={C.amb} fontSize="10" fontWeight="800">FLIP {num(v.gamma_flip)}</text>);
  }
  return <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width: '100%', height: 'auto', display: 'block' }}>{els}</svg>;
}

function WallTable(props) {
  var rows = props.rows || [], pick = props.pick;
  return (
    <div style={{ ...cardBase, flex: 1, minWidth: 260 }}>
      <div style={{ ...LBL, color: props.color, marginBottom: 6 }}>{props.title}</div>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 11, color: '#c4cfd8' }}>
        <thead><tr>
          {['STRIKE', 'OI', 'ΔOI', 'GEX', 'DEX', '₹', 'SCORE'].map(function (h, i) {
            return <th key={h} style={{ color: C.mut, fontWeight: 800, fontSize: 9, padding: '4px 2px', textAlign: i ? 'right' : 'left' }}>{h}</th>;
          })}
        </tr></thead>
        <tbody>
          {rows.map(function (r) {
            var hi = r.strike === pick;
            var td = { padding: '4px 2px', textAlign: 'right' };
            return (
              <tr key={r.strike} style={{ background: hi ? 'rgba(167,139,250,0.10)' : 'transparent' }}>
                <td style={{ ...td, textAlign: 'left', fontWeight: hi ? 800 : 400 }}>{num(r.strike)}{hi ? <span style={{ color: C.vio, fontSize: 9 }}> ◀</span> : null}</td>
                <td style={td}>{fmtOI(r.oi)}</td>
                <td style={{ ...td, color: (r.oi_chg || 0) >= 0 ? C.grn : C.red }}>{(r.oi_chg || 0) >= 0 ? '+' : ''}{fmtOI(r.oi_chg)}</td>
                <td style={td}>{Math.round(r.gex)}</td>
                <td style={td}>{Math.round(r.dex)}</td>
                <td style={td}>{r.ltp}</td>
                <td style={{ ...td, fontWeight: hi ? 800 : 400 }}>{(r.score || 0).toFixed(2)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}


// ── flow-bias timeline (Hybrid Conviction style) ────────────────────
function hmsToSec(t) { var p = String(t || '').split(':'); return (+p[0] || 0) * 3600 + (+p[1] || 0) * 60 + (+p[2] || 0); }
var BT_START = hmsToSec('09:17:00'), BT_END = hmsToSec('15:30:00');
function BiasTimeline(props) {
  var h = props.history || [], thr = (props.threshold || 0.25) * 100;
  var has = h.length >= 2;
  var X0 = 35, XW = 955;
  function toX(t) { return X0 + Math.max(0, Math.min(1, (hmsToSec(t) - BT_START) / (BT_END - BT_START))) * XW; }
  function toY(v) { return 15 + ((100 - Math.max(-100, Math.min(100, v))) / 200) * 170; }
  var pts = h.map(function (p) { return toX(p.time) + ',' + toY((p.bias || 0) * 100); }).join(' ');
  var last = h[h.length - 1] || { time: '09:17:00', bias: 0 }, lv = (last.bias || 0) * 100;
  var lc = lv > 8 ? '#00d4aa' : lv < -8 ? '#ff4466' : '#8899aa';
  var zones = [[8, 25, 'rgba(125,211,168,0.04)'], [25, 50, 'rgba(0,212,170,0.05)'], [50, 100, 'rgba(0,212,170,0.08)'],
               [-8, -25, 'rgba(244,160,160,0.04)'], [-25, -50, 'rgba(255,68,102,0.05)'], [-50, -100, 'rgba(255,68,102,0.08)']];
  var ticks = ['09:17:00', '10:30:00', '11:45:00', '13:00:00', '14:15:00', '15:30:00'];
  return (
    <div style={{ background: 'rgba(13,21,38,0.8)', borderRadius: 8, padding: 14, border: '1px solid rgba(26,45,74,0.4)', marginBottom: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
        <div style={{ fontSize: 9, color: '#556677', fontWeight: 700, textTransform: 'uppercase' }}>Flow Bias Timeline <span style={{ fontWeight: 400 }}>· + put-side building (bullish) · − call-side building (bearish)</span></div>
        <div style={{ fontSize: 9, color: '#556677' }}>{h.length} pts · 10s · dashed = DEX tilt ±{Math.round(thr)}</div>
      </div>
      <svg viewBox="0 0 1000 200" style={{ width: '100%', height: 200 }}>
        {[-100, -50, 0, 50, 100].map(function (v) {
          var y = toY(v);
          return <g key={v}><line x1={X0} y1={y} x2="990" y2={y} stroke={v === 0 ? 'rgba(120,140,160,0.3)' : 'rgba(100,120,140,0.1)'} strokeWidth={v === 0 ? 1 : 0.5} strokeDasharray={v === 0 ? '' : '2'} /><text x="32" y={y + 3} fill="#556677" fontSize="8" textAnchor="end">{v > 0 ? '+' : ''}{v}</text></g>;
        })}
        {zones.map(function (z, i) {
          var y1 = toY(Math.max(z[0], z[1])), y2 = toY(Math.min(z[0], z[1]));
          return <rect key={i} x={X0} y={y1} width={XW} height={y2 - y1} fill={z[2]} />;
        })}
        {[thr, -thr].map(function (v) { return <line key={'t' + v} x1={X0} y1={toY(v)} x2="990" y2={toY(v)} stroke={v > 0 ? 'rgba(0,212,170,0.35)' : 'rgba(255,68,102,0.35)'} strokeWidth="0.8" strokeDasharray="4 3" />; })}
        {has ? <polyline fill="none" stroke="#0ea5e9" strokeWidth="1.5" points={pts} /> : null}
        {has ? <circle cx={toX(last.time)} cy={toY(lv)} r="3.5" fill={lc} stroke="#0a0f1e" strokeWidth="1.5" /> : null}
        {has ? <text x={toX(last.time) - 6} y={toY(lv) - 7} fill={lc} fontSize="10" fontWeight="800" textAnchor="end">{lv >= 0 ? '+' : ''}{Math.round(lv)}</text> : null}
        {!has ? <text x="512" y="104" fill="#556677" fontSize="12" textAnchor="middle">No data yet — fills every 10s from 09:17 to 15:30</text> : null}
        {ticks.map(function (t) { return <text key={t} x={toX(t)} y="198" fill="#556677" fontSize="8" textAnchor="middle">{t.slice(0, 5)}</text>; })}
      </svg>
    </div>
  );
}

var Positioning = function () {
  var [state, setState] = useState(null);
  var [err, setErr] = useState('');
  var [tab, setTab] = useState('gex');
  var [fresh, setFresh] = useState(true);
  var [showChg, setShowChg] = useState(false);
  var [showCfg, setShowCfg] = useState(false);
  var [draft, setDraft] = useState({});

  var fetchState = useCallback(function () {
    fetch(API + '/positioning/state').then(function (r) { return r.json(); }).then(function (d) {
      if (d && !d.error) { setState(d); setErr(''); } else setErr((d && d.error) || 'unavailable');
    }).catch(function () { setErr('backend unreachable'); });
  }, []);

  useEffect(function () {
    fetchState();
    var id = setInterval(fetchState, 2000);
    function wake() { if (!document.hidden) fetchState(); }
    document.addEventListener('visibilitychange', wake);
    return function () { clearInterval(id); document.removeEventListener('visibilitychange', wake); };
  }, [fetchState]);

  var cfg = (state && state.config) || {};
  var v = (state && state.view) || {};
  var s = v.suggestion || {};
  var pos = state && state.position;
  var st = (state && state.stats) || {};
  var trades = (state && state.trades) || [];
  var events = (state && state.events) || [];

  function postCfg(p, close) {
    fetch(API + '/positioning/config', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(p) })
      .then(function () { if (close) setShowCfg(false); setTimeout(fetchState, 400); });
  }
  var STR = { entry_time: 1, exit_time: 1, expiry_choice: 1, neg_gamma_mode: 1 };
  var BOOL = { enabled: 1, dex_tilt: 1, regime_roll: 1 };
  function openCfg() {
    var d = {};
    Object.keys(cfg).forEach(function (k) { d[k] = BOOL[k] ? (cfg[k] ? 1 : 0) : cfg[k]; });
    setDraft(d); setShowCfg(true);
  }
  function saveCfg() {
    var p = {};
    Object.keys(draft).forEach(function (k) {
      var val = draft[k];
      p[k] = STR[k] ? val : BOOL[k] ? Number(val) === 1 : Number(val);
    });
    postCfg(p, true);
  }
  function D(k) { return function (val) { var d = Object.assign({}, draft); d[k] = val; setDraft(d); }; }

  var regimePos = v.regime === 'positive';
  var bias = v.bias || 0;
  var biasLbl = bias > 0.25 ? 'Bullish' : bias > 0.08 ? 'Slightly bullish' : bias < -0.25 ? 'Bearish' : bias < -0.08 ? 'Slightly bearish' : 'Neutral';
  var biasCol = bias > 0.08 ? C.grn : bias < -0.08 ? C.red : C.sub;
  var conf = s.confidence || 0;
  var confCol = conf >= 65 ? C.grn : conf >= 40 ? C.amb : C.red;
  var stCol = { ok: C.grn, warn: C.amb, bad: C.red };
  var stSym = { ok: '✓', warn: '~', bad: '✗' };
  var legend = tab === 'gex' ? 'Net dealer gamma (₹Cr per 1% move; calls +, puts −). Outlined bars = gamma walls · amber = gamma flip'
    : tab === 'dex' ? (fresh ? 'FRESH delta — today’s OI change × delta (₹Cr). Put-side building reads bullish.' : 'TOTAL OI-weighted delta (₹Cr), calls +, puts −.')
    : tab === 'oi' ? 'Red = call OI · green = put OI · solid = suggested strikes' + (showChg ? ' · white = today’s added OI' : '')
    : 'Sell-score per strike (OI ' + (cfg.w_oi || 45) + ' · GEX ' + (cfg.w_gex || 35) + ' · distance ' + (cfg.w_dist || 20) + '; DEX tilts the pair). Outlined = suggested legs.';
  var tabBtn = function (id, label) {
    var on = tab === id;
    return <button key={id} onClick={function () { setTab(id); }} style={{ background: on ? 'rgba(56,189,248,0.15)' : '#0d1524', color: on ? C.blu : C.sub, border: '1px solid ' + (on ? 'rgba(56,189,248,0.5)' : '#26334a'), borderRadius: 8, padding: '6px 16px', fontWeight: 800, fontSize: 11, cursor: 'pointer', fontFamily: 'inherit' }}>{label}</button>;
  };
  var smallBtn = { fontSize: 10, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', borderRadius: 6, padding: '3px 9px', background: 'transparent', border: '1px solid #26334a', color: C.sub };

  return (
    <div style={{ padding: '18px 22px', color: '#e5e7eb', fontFamily: 'inherit', maxWidth: 1300 }}>
      {/* HEADER */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 10 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800 }}>🧭 NIFTY Positioning</div>
          <div style={{ fontSize: 10, color: C.mut, marginTop: 3 }}>
            GEX · DEX · OI by strike → one suggested strangle · expiry {v.expiry_iso || '--'} · updated {(state && state.view_time) || '--'}
          </div>
        </div>
        <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
          {v.regime ? <Chip color={regimePos ? C.grn : C.red}>{regimePos ? 'POSITIVE GAMMA · RANGE' : 'NEGATIVE GAMMA · TREND'}</Chip> : null}
          {state && state.is_expiry_day ? <Chip color={C.amb}>EXPIRY DAY</Chip> : null}
          <select value={cfg.expiry_choice || 'current_week'} onChange={function (e) { postCfg({ expiry_choice: e.target.value }); }}
            style={{ background: 'rgba(56,189,248,0.1)', color: C.blu, border: '1px solid rgba(56,189,248,0.5)', borderRadius: 6, fontSize: 10, fontWeight: 800, padding: '3px 6px', fontFamily: 'inherit' }}>
            <option value="current_week">Expiry: This week</option>
            <option value="next_week">Expiry: Next week</option>
          </select>
          <button onClick={openCfg} style={{ fontSize: 11, fontWeight: 800, cursor: 'pointer', background: 'transparent', color: C.sub, border: '1px solid ' + C.line, borderRadius: 8, padding: '6px 12px', fontFamily: 'inherit' }}>⚙</button>
        </div>
      </div>

      {err ? <div style={{ ...cardBase, borderColor: 'rgba(251,191,36,0.45)', color: C.amb, fontSize: 11, marginBottom: 12 }}>Positioning: {err}</div> : null}

      <div style={{ display: 'flex', gap: 12, marginBottom: 12, flexWrap: 'wrap' }}>
        <Stat label="SPOT" value={v.spot ? num(Math.round(v.spot * 10) / 10) : '--'} />
        <Stat label="ATM" value={num(v.atm)} />
        <Stat label="NET GEX" value={fmtCr(v.net_gex, true)} color={(v.net_gex || 0) >= 0 ? C.grn : C.red} />
        <Stat label="GAMMA FLIP" value={num(v.gamma_flip)} />
        <Stat label="NET DEX (fresh)" value={fmtCr(v.fresh_dex, true)} />
        <Stat label="PCR (OI)" value={v.pcr != null ? v.pcr : '--'} />
        <Stat label="EXPECTED MOVE" value={v.expected_move ? '±' + Math.round(v.expected_move) : '--'} />
      </div>

      {/* CHART + SUGGESTION */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 12, flexWrap: 'wrap', alignItems: 'stretch' }}>
        <div style={{ ...cardBase, flex: 2.2, minWidth: 340 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6, flexWrap: 'wrap', gap: 6 }}>
            <span style={LBL}>BY STRIKE</span>
            <span style={{ display: 'flex', gap: 6 }}>{tabBtn('gex', 'GEX')}{tabBtn('dex', 'DEX')}{tabBtn('oi', 'OI')}{tabBtn('all', 'COMBINED')}</span>
          </div>
          <StrikeChart rows={v.chart} tab={tab} view={v} fresh={fresh} showChg={showChg} />
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, marginTop: 6, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 10, color: C.mut }}>{legend}</span>
            {tab === 'dex' ? <button style={smallBtn} onClick={function () { setFresh(!fresh); }}>{fresh ? 'Show total' : 'Show fresh'}</button> : null}
            {tab === 'oi' ? <button style={smallBtn} onClick={function () { setShowChg(!showChg); }}>{showChg ? 'Hide ΔOI' : 'Show ΔOI'}</button> : null}
          </div>
        </div>

        <div style={{ ...cardBase, flex: 1, minWidth: 280, borderColor: 'rgba(167,139,250,0.45)' }}>
          <div style={{ ...LBL, color: C.vio }}>SUGGESTED STRANGLE</div>
          {s.action === 'AVOID' ? (
            <div style={{ margin: '14px 0', padding: 12, borderRadius: 10, background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.4)', color: C.red, fontWeight: 800, fontSize: 13, textAlign: 'center' }}>
              NO TRADE — negative gamma (avoid mode)
            </div>
          ) : s.ce_strike && s.pe_strike ? (
            <div>
              <div style={{ display: 'flex', gap: 8, margin: '10px 0 6px' }}>
                {[['SELL CE', s.ce_strike, s.ce_ltp, C.red], ['SELL PE', s.pe_strike, s.pe_ltp, C.grn]].map(function (x) {
                  return (
                    <div key={x[0]} style={{ flex: 1, background: '#0d1524', borderRadius: 10, padding: 10, textAlign: 'center' }}>
                      <div style={{ fontSize: 9, fontWeight: 800, color: x[3] }}>{x[0]}</div>
                      <div style={{ fontSize: 24, fontWeight: 800 }}>{num(x[1])}</div>
                      <div style={{ fontSize: 11, color: C.sub }}>₹{x[2]}</div>
                    </div>
                  );
                })}
              </div>
              <div style={{ fontSize: 11, lineHeight: 1.9 }}>
                Credit <b>₹{s.credit}</b> · ₹{num(s.credit_per_lot)}/lot<br />
                Breakevens <b>{num(s.be_low)} – {num(s.be_high)}</b> · width {s.width}<br />
                Room vs expected move: CE +{Math.round(s.ce_room)} · PE −{Math.round(s.pe_room)}
              </div>
            </div>
          ) : <div style={{ fontSize: 11, color: C.mut, padding: '20px 0', textAlign: 'center' }}>No qualifying strikes yet.</div>}
          <div style={{ ...LBL, margin: '10px 0 4px' }}>CONFIDENCE</div>
          <div style={{ height: 8, background: '#0d1524', borderRadius: 6, overflow: 'hidden' }}>
            <div style={{ width: conf + '%', height: '100%', background: 'linear-gradient(90deg,' + C.vio + ',' + confCol + ')' }} />
          </div>
          <div style={{ fontSize: 11, fontWeight: 800, marginTop: 4, color: confCol }}>{conf} / 100 · {conf >= 65 ? 'GOOD' : conf >= 40 ? 'FAIR' : 'WEAK'}</div>
          <div style={{ marginTop: 10, fontSize: 11, lineHeight: 1.75 }}>
            {(s.reasons || []).map(function (r, i) {
              return <div key={i}><span style={{ color: stCol[r.st], fontWeight: 800 }}>{stSym[r.st]}</span> <b>{r.sig}</b> — {r.text}</div>;
            })}
          </div>
          <div style={{ fontSize: 10, color: C.mut, marginTop: 6 }}>Paper trades this suggestion · {cfg.entry_time || '09:17'}–{cfg.exit_time || '15:00'} · checks every {cfg.check_interval_sec || 5}s</div>
        </div>
      </div>

      {/* WALLS / BIAS / TAKEAWAYS */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 12, flexWrap: 'wrap' }}>
        <WallTable title="TOP CALL WALLS" color={C.red} rows={v.call_table} pick={s.ce_strike} />
        <WallTable title="TOP PUT WALLS" color={C.grn} rows={v.put_table} pick={s.pe_strike} />
        <div style={{ ...cardBase, flex: 0.8, minWidth: 200 }}>
          <div style={{ ...LBL, marginBottom: 8 }}>DEALER / FLOW BIAS</div>
          <div style={{ fontWeight: 800, fontSize: 13, color: biasCol }}>{biasLbl}</div>
          <div style={{ height: 8, background: '#0d1524', borderRadius: 6, margin: '8px 0', position: 'relative', overflow: 'hidden' }}>
            <div style={{ position: 'absolute', left: bias >= 0 ? '50%' : (50 + bias * 50) + '%', width: Math.abs(bias) * 50 + '%', height: '100%', background: biasCol }} />
            <div style={{ position: 'absolute', left: '50%', top: 0, width: 2, height: '100%', background: C.mut }} />
          </div>
          <div style={{ fontSize: 11, lineHeight: 1.8 }}>
            Call GEX <b>{fmtCr(v.call_gex, true)}</b><br />
            Put GEX <b>{fmtCr(v.put_gex, true)}</b><br />
            Total DEX <b>{fmtCr(v.net_dex, true)}</b><br />
            Fresh DEX <b style={{ color: biasCol }}>{fmtCr(v.fresh_dex, true)}</b>
          </div>
        </div>
        <div style={{ ...cardBase, flex: 1, minWidth: 240 }}>
          <div style={{ ...LBL, color: C.amb, marginBottom: 8 }}>KEY TAKEAWAYS</div>
          <ol style={{ margin: 0, paddingLeft: 16, fontSize: 11, lineHeight: 1.8, color: C.sub }}>
            {(v.takeaways || []).map(function (t, i) { return <li key={i}>{t}</li>; })}
          </ol>
        </div>
      </div>

      <BiasTimeline history={state && state.bias_history} threshold={cfg.dex_tilt_threshold} />

      {/* PAPER */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 12, flexWrap: 'wrap' }}>
        <div style={{ ...cardBase, flex: 1.2, minWidth: 300 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8, alignItems: 'center' }}>
            <span style={LBL}>PAPER POSITION {cfg.enabled === false ? '· DISABLED' : ''}{state && state.day_stopped ? ' · STOPPED ' + state.day_stopped : ''}</span>
            <span style={{ fontSize: 13, fontWeight: 800, color: (st.day_pnl || 0) >= 0 ? C.grn : C.red }}>{fmtINR(st.day_pnl)}</span>
          </div>
          {pos ? (
            <div style={{ fontSize: 11, lineHeight: 1.9 }}>
              <div style={{ fontWeight: 800, color: C.blu }}>{pos.lots}L · since {pos.opened} · credit {pos.credit} · conf {pos.confidence} at entry</div>
              {pos.legs.map(function (l, i) {
                var pend = state.pending_roll && state.pending_roll[l.side];
                return (
                  <div key={i} style={{ color: C.sub }}>
                    <span style={{ fontWeight: 800, color: l.side === 'CE' ? C.red : C.grn }}>SELL</span> {num(l.strike)} {l.side} @ {l.entry} → {l.ltp}
                    <span style={{ fontSize: 9, color: C.mut, marginLeft: 6 }}>{l.rank ? '#' + l.rank : 'unranked'}{l.rank && l.rank <= (cfg.hold_rank || 3) ? ' in zone' : ''} · Δ{l.delta != null ? l.delta : '--'}</span>
                    {pend ? <span style={{ fontSize: 9, color: C.amb, marginLeft: 6 }}>{pend.why} → {pend.strike} ({pend.ticks}/{cfg.roll_confirm_ticks})</span> : null}
                    <span style={{ float: 'right', fontWeight: 800, color: (l.pnl || 0) >= 0 ? C.grn : C.red }}>{fmtINR(l.pnl)}</span>
                  </div>
                );
              })}
            </div>
          ) : (
            <div style={{ fontSize: 10, color: C.mut, padding: '14px 0', textAlign: 'center' }}>
              {state && state.entered_today ? 'Done for the day.' : cfg.enabled === false ? 'Paper trading is disabled in settings.' : 'Flat — enters the suggestion at ' + (cfg.entry_time || '09:17') + '.'}
            </div>
          )}
          <div style={{ display: 'flex', gap: 8, marginTop: 10, flexWrap: 'wrap' }}>
            {[['REALIZED', st.realized], ['UNREALIZED', st.unrealized]].map(function (x) {
              return <div key={x[0]} style={{ flex: 1, background: '#0d1524', borderRadius: 8, padding: '6px 8px', textAlign: 'center' }}>
                <div style={{ fontSize: 8, fontWeight: 800, color: C.mut }}>{x[0]}</div>
                <div style={{ fontSize: 13, fontWeight: 800, color: (x[1] || 0) >= 0 ? C.grn : C.red }}>{fmtINR(x[1])}</div>
              </div>;
            })}
            <div style={{ flex: 1, background: '#0d1524', borderRadius: 8, padding: '6px 8px', textAlign: 'center' }}>
              <div style={{ fontSize: 8, fontWeight: 800, color: C.mut }}>ROLLS CE / PE</div>
              <div style={{ fontSize: 13, fontWeight: 800, color: C.amb }}>{st.rolls_ce || 0} / {st.rolls_pe || 0}</div>
            </div>
          </div>
          {trades.length ? (
            <div style={{ marginTop: 10, fontSize: 10, lineHeight: 1.8 }}>
              {trades.map(function (t, i) {
                return <div key={i} style={{ color: C.sub }}>{t.closed} · {t.type} · {t.reason}<span style={{ float: 'right', fontWeight: 800, color: (t.pnl || 0) >= 0 ? C.grn : C.red }}>{fmtINR(t.pnl)}</span></div>;
              })}
            </div>
          ) : null}
        </div>
        <div style={{ ...cardBase, flex: 1, minWidth: 280 }}>
          <div style={{ ...LBL, marginBottom: 8 }}>ACTIVITY LOG</div>
          <div style={{ maxHeight: 260, overflowY: 'auto' }}>
            {events.length ? events.slice().reverse().map(function (ev, i) {
              return <div key={i} style={{ fontSize: 10, color: C.sub, padding: '3px 0', borderBottom: '1px solid #0d1524' }}><span style={{ color: C.mut }}>{ev.time}</span> {ev.text}</div>;
            }) : <div style={{ fontSize: 10, color: C.mut, textAlign: 'center', padding: '14px 0' }}>Quiet.</div>}
          </div>
        </div>
      </div>

      {/* SETTINGS */}
      {showCfg ? (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(3,6,12,0.75)', zIndex: 60, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', overflowY: 'auto', padding: '40px 16px' }}
          onClick={function (e) { if (e.target === e.currentTarget) setShowCfg(false); }}>
          <div style={{ background: '#0b1220', border: '1px solid #26334a', borderRadius: 14, padding: '22px 26px', width: '100%', maxWidth: 600 }}>
            <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 4 }}>Positioning Settings</div>
            <div style={{ fontSize: 10, color: C.mut, marginBottom: 16 }}>Signals only — paper trades, no orders.</div>

            <div style={{ ...LBL, margin: '0 0 10px' }}>PAPER</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <Field label="Paper Trading" value={draft.enabled} onChange={D('enabled')} options={[[1, 'ON'], [0, 'OFF (view only)']]} />
              <Field label="Lots" type="number" value={draft.paper_lots} onChange={D('paper_lots')} />
              <Field label="Entry Time" value={draft.entry_time} onChange={D('entry_time')} />
              <Field label="Exit Time" value={draft.exit_time} onChange={D('exit_time')} />
              <Field label="Check Interval (s)" type="number" value={draft.check_interval_sec} onChange={D('check_interval_sec')} />
              <Field label="Min Confidence to Enter" hint="(0 = always)" type="number" value={draft.min_confidence} onChange={D('min_confidence')} />
            </div>

            <div style={{ ...LBL, margin: '20px 0 10px' }}>SCORING WEIGHTS</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 14 }}>
              <Field label="OI" type="number" value={draft.w_oi} onChange={D('w_oi')} />
              <Field label="GEX" type="number" value={draft.w_gex} onChange={D('w_gex')} />
              <Field label="Distance" type="number" value={draft.w_dist} onChange={D('w_dist')} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginTop: 14 }}>
              <Field label="Candidate Band" hint="(ATM±N strikes)" type="number" value={draft.band} onChange={D('band')} />
              <Field label="Min Premium ₹" type="number" value={draft.min_premium} onChange={D('min_premium')} />
              <Field label="Expected Move ×" hint="(of ATM straddle)" type="number" value={draft.em_mult} onChange={D('em_mult')} />
              <Field label="Negative Gamma" value={draft.neg_gamma_mode} onChange={D('neg_gamma_mode')}
                options={[['widen', 'Widen both legs 1 strike'], ['avoid', 'Avoid — no trade'], ['ignore', 'Ignore']]} />
              <Field label="DEX Tilt" value={draft.dex_tilt} onChange={D('dex_tilt')} options={[[1, 'ON — shift pair 1 strike'], [0, 'OFF']]} />
              <Field label="Tilt Threshold" hint="(|bias| 0–1)" type="number" value={draft.dex_tilt_threshold} onChange={D('dex_tilt_threshold')} />
            </div>

            <div style={{ ...LBL, margin: '20px 0 10px' }}>ROLLS <span style={{ color: C.mut, fontWeight: 400 }}>(a leg rolls only on a tilt change, a regime change if enabled, leaving the hold zone, or a delta breach — after the confirm checks · no strike is ever sold above Max Sell Delta)</span></div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <Field label="Confirm Checks" hint="(× interval)" type="number" value={draft.roll_confirm_ticks} onChange={D('roll_confirm_ticks')} />
              <Field label="Hold Zone" value={draft.hold_rank} onChange={D('hold_rank')}
                options={[[3, 'Top 3 — hold while #1–#3'], [2, 'Top 2 — hold while #1–#2']]} />
              <Field label="Breach Delta" hint="(|Δ| above = roll)" type="number" value={draft.breach_delta} onChange={D('breach_delta')} />
              <Field label="Roll Score Margin %" hint="(target must beat held by)" type="number" value={draft.roll_margin_pct} onChange={D('roll_margin_pct')} />
              <Field label="No-Return Window min" hint="(0=off · breach exempt)" type="number" value={draft.no_return_min} onChange={D('no_return_min')} />
              <Field label="Max Sell Delta" hint="(entry & roll target · 0=off)" type="number" value={draft.max_sell_delta} onChange={D('max_sell_delta')} />
              <Field label="Regime Rolls" value={draft.regime_roll} onChange={D('regime_roll')}
                options={[[0, 'OFF — walls already reflect regime'], [1, 'ON — roll when regime flips']]} />
              <Field label="Fill Haircut % / leg" type="number" value={draft.spread_haircut_pct} onChange={D('spread_haircut_pct')} />
            </div>

            <div style={{ ...LBL, margin: '20px 0 10px' }}>PROFIT MANAGEMENT <span style={{ color: C.mut, fontWeight: 400 }}>(₹ per lot · any trigger exits &amp; stops the day)</span></div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <Field label="MTM SL ₹/lot" hint="(0=off)" type="number" value={draft.mtm_sl_per_lot} onChange={D('mtm_sl_per_lot')} />
              <Field label="Target ₹/lot" hint="(0=off)" type="number" value={draft.target_per_lot} onChange={D('target_per_lot')} />
              <Field label="Protect ₹/lot" hint="(0=off)" type="number" value={draft.protect_per_lot} onChange={D('protect_per_lot')} />
              <Field label="Protect Level ₹/lot" type="number" value={draft.protect_level_per_lot} onChange={D('protect_level_per_lot')} />
              <Field label="Trail Step ₹/lot" hint="(0=off)" type="number" value={draft.trail_step_per_lot} onChange={D('trail_step_per_lot')} />
            </div>

            <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
              <button onClick={function () { setShowCfg(false); }}
                style={{ flex: 1, fontSize: 13, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', background: '#0d1524', color: '#c4cfd8', border: '1px solid #26334a', borderRadius: 10, padding: '12px 0' }}>Cancel</button>
              <button onClick={saveCfg}
                style={{ flex: 1, fontSize: 13, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', background: 'rgba(34,197,94,0.15)', color: C.grn, border: '1px solid rgba(34,197,94,0.5)', borderRadius: 10, padding: '12px 0' }}>Save</button>
            </div>
            <div style={{ marginTop: 14, textAlign: 'center' }}>
              <button onClick={function () { fetch(API + '/positioning/reset-paper', { method: 'POST' }).then(function () { setShowCfg(false); setTimeout(fetchState, 400); }); }}
                style={{ fontSize: 10, fontWeight: 800, cursor: 'pointer', background: 'transparent', color: C.red, border: '1px solid rgba(239,68,68,0.4)', borderRadius: 8, padding: '6px 16px', fontFamily: 'inherit' }}>Reset paper · clears day-stop &amp; re-arms entry</button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Positioning;
